import { EpimsBaseEntityDto } from './epim-base.dto';
export class ProgramConfigDto extends EpimsBaseEntityDto   {
    ContractorId: string;
    ContractorName: string;
    OMLId: string;
    OMLName: string;
    ProgramId: string;
    ProgramName: string;
    SwathNo: string;
    SwathNoName: string;
    CommunityId: string;
    CommunityName: string;
    Budget: number;
    Name: string;
    AboveBudget: boolean;
    Description: string;
    TotalApproved: number;
    TotalApprovedByCurrentUser: number;
}